import * as React from 'react';
import {
    Table,
    Button,
    Form,
    FormControl,
    Checkbox,
    HelpBlock,
    FormGroup,
    ControlLabel,
    Row
} from 'react-bootstrap';
import { Translate } from '../../../shared/LanguageService';
import FormInputChangeHandler from '../../../shared/form/FormInputChangeHandler';
import FormSelect from '../../../components/common/FormSelect';

class BrokerFirmList extends React.Component<any, any> {
    formInputChangeHandler: FormInputChangeHandler;

    constructor(props: any, context: any) {
        super(props, context);

        this.state = {
            selectedValue: 0
        };

        this.setValue = this.setValue.bind(this);
        this.formInputChangeHandler = new FormInputChangeHandler(this.state, this.setValue);
    }

    setValue(newState: any) {
        this.setState(newState);
    }

    getAvailableFirms() {
        return this.props.availableFirms.filter(
            (x: any) => !this.props.firms.find((y: any) => x.id === y.id)
        );
    }

    render() {
        return (
            <div>
                <ControlLabel>{Translate('broker-agent/form/firm')}</ControlLabel>
                <Form inline>
                    <FormGroup>
                        <FormSelect
                            name="selectedValue"
                            value={this.state.selectedValue}
                            onChange={this.formInputChangeHandler.onChange}
                        >
                            <option value="0">{Translate('broker-agent/form/select-firm')}</option>
                            {this.getAvailableFirms()
                                .sort((a, b) => {
                                    if (a.name < b.name) {
                                        return -1;
                                    }
                                    if (a.name > b.name) {
                                        return 1;
                                    }

                                    return 0;
                                })
                                .map((x: any) => (
                                    <option value={x.id} key={x.id}>
                                        {x.name}
                                    </option>
                                ))}
                        </FormSelect>
                    </FormGroup>
                    <Button
                        bsSize="small"
                        bsStyle="success"
                        disabled={
                            this.getAvailableFirms().length === 0 || this.state.selectedValue === 0
                        }
                        onClick={() => {
                            this.props.add(this.state.selectedValue);
                            this.setState({ selectedValue: 0 });
                        }}
                    >
                        {Translate('broker-agent/form/button/add-firm')}{' '}
                        <i className="material-icons">add</i>
                    </Button>
                </Form>
                <Table hover responsive>
                    <thead>
                        <tr>
                            <th>{Translate('broker-agent/form/firms/table/connected-firms')}</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.firms
                            .sort((a, b) => {
                                if (a.name < b.name) {
                                    return -1;
                                }
                                if (a.name > b.name) {
                                    return 1;
                                }

                                return 0;
                            })
                            .map((x: any, index: number) => {
                                return (
                                    <tr key={index}>
                                        <td>{x.name}</td>
                                        <td className="tools">
                                            <Button
                                                bsSize="small"
                                                bsStyle="danger"
                                                onClick={() => this.props.remove(index)}
                                            >
                                                <i className="material-icons">delete_forever</i>
                                            </Button>
                                        </td>
                                    </tr>
                                );
                            })}
                    </tbody>
                </Table>
            </div>
        );
    }
}

export default BrokerFirmList;
